import appConfig from '../../config/app';
import { getAuthHeaders } from '../fetchers/auth';

const buildNewsFeedEndpoints = (gymUid) => [
  `${appConfig.baseApiUrl}/api/v1/gyms/${gymUid}/news_posts`,
];

export async function createNewsPost(gymUid, postData) {
  if (!gymUid) {
    throw new Error('Missing gym for news post');
  }

  const options = await getAuthHeaders();
  const endpoints = buildNewsFeedEndpoints(gymUid);

  const payload = {
    title: postData.title,
    body: postData.body,
    notify_users: Boolean(postData.notify_users),
    image_url: postData.image_url || '',
    links: Array.isArray(postData.links) ? postData.links : [],
  };

  for (const endpoint of endpoints) {
    const response = await fetch(endpoint, {
      method: 'POST',
      headers: {
        ...options,
      },
      body: JSON.stringify(payload),
    });

    if (response.ok) {
      return response.json();
    }

    if (response.status !== 404) {
      const errorPayload = await response.json().catch(() => null);
      throw new Error(errorPayload?.error || 'Unable to create post');
    }
  }

  throw new Error('News feed endpoint unavailable');
}
